import { Box, Paper, Typography } from "@mui/material";
import React from "react";

const ReviewFormDetails = () => {
  return (
    <Box>
      <Paper elevation={3} sx={{ backgroundColor: "#F6F7FA" }}>
        <Box sx={{ display: "flex", flexDirection: "column", padding: "14px" }}>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" fontSize="16px" fontWeight={800}>
              Started
            </Typography>
            <Typography variant="h6" fontSize="14px">
              September 10, 2023 5:00 pm
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" fontSize="16px" fontWeight={800}>
              Review Cycle
            </Typography>
            <Typography variant="h6" fontSize="14px" color={"#146ED2"}>
              Performance Check in (Current)
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" fontSize="16px" fontWeight={800}>
              Review Forms
            </Typography>
            <Typography variant="h6" fontSize="14px">
              5 / 5
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Typography variant="h6" fontSize="16px" fontWeight={800}>
              Actions Involved
            </Typography>
            <Typography variant="h6" fontSize="14px">
              3 / 5
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ReviewFormDetails;
